import { TSelect } from "../gui/Select/Select";
import CacheMan from "../jslibs/CacheMan";
import GError from "../jslibs/GError";
import Usernames from "../libs/login/Usernames";
import Recipes, { IFoodAmount, IRecipe, TUnits } from "../shared/Recipes";
import FoodApi from "./FoodApi";
import Foods from "./Foods";
import { ICache } from "./ICache";

export const UnitOptions:TSelect<string>[] = TUnits.map(unit => ({id:unit,text:unit}))
export function unit2option(unit:string) : TSelect<string> { return UnitOptions.find(u => u.id==unit)! }

export default class RecipeCache extends CacheMan<string, Recipes> implements ICache<IRecipe> {
    static _i:RecipeCache
    static get i(){
        if (!this._i) this._i = new RecipeCache("recipes", 3600)
        return this._i
    }
    async fetch(userId:string): Promise<Recipes> {
        return new Recipes(userId, await FoodApi.i.recipes())
    }
    async fetchBatch(keys: string[]): Promise<Recipes[]> {
        throw "Not implemented"
    }
    async getRecipes(){
        if (!FoodApi.i.userId) throw new GError.NotAuthorized()
        return  this.get(FoodApi.i.userId)
    }
    async addRecipe(name:string,desc:string,servings:number){
        const recipes = await this.getRecipes()
        const recipe = await FoodApi.i.addRecipe(name,desc,servings)
        recipes.update(recipe)
        this.add(recipes.userId, recipes.update(recipe))
        return recipe
    }
    async getItem(id:string) { return this.getRecipes().then(all => all.find(id)!) }
    async updateItem(id:string, data:Partial<IRecipe>) { 
        const recipes = await this.getRecipes()
        const recipe = await FoodApi.i.updateRecipe(id, data)
        recipes.update(recipe)
        this.add(recipes.userId, recipes.update(recipe))
        return recipe
    }
    async removeItem(id:string){
        const recipes = await this.getRecipes()
        await FoodApi.i.removeRecipe(id)
        recipes.deleteKey(id)
        this.add(recipes.userId, recipes)
    }
    static getFacts(facts:Map<number,number>, foods:IFoodAmount[], portion:number){
        for(const foodAmount of foods){
            const food = Foods.i.fromCache(foodAmount.id.toString())
            if (!food) continue

            const amountInGrams = Foods.amountInGrams(food, foodAmount.amount, foodAmount.unit)
            for(const fact of food.facts) {
                const current = facts.get(fact.nid) || 0
                facts.set(fact.nid, current + amountInGrams/100*fact.amount*portion)
            }
        }
        return facts
    }
    
    itemName(item:IRecipe) { return item.name }
    itemId(item:IRecipe) { return item._id }
}
